"use client";

import { GradientBorder } from "@/component/GradientBorder";
import classNames from "classnames";

interface EditorContainerProps {
  isActive?: boolean;
  containerClassName?: string;
  className?: string;
  children: React.ReactNode;
}

/**
 * 编辑器容器组件 - 提供统一的渐变边框和激活状态样式
 */
export function EditorContainer(props: EditorContainerProps) {
  const { isActive = false, containerClassName, className, children } = props;

  return (
    <div
      className={classNames(containerClassName, "relative rounded-xl p-0.5")}
    >
      {/* 渐变边框 - 仅在激活时显示 */}
      {isActive && (
        <GradientBorder
          className="absolute inset-0 pointer-events-none transition-opacity duration-300"
          borderWidth={2}
          borderRadius={16}
          from="#5251f6"
          to="#ff1e69"
          direction="horizontal"
        />
      )}

      {/* 内容容器 */}
      <div
        className={classNames(
          "relative w-full h-full flex flex-col justify-between rounded-[14px] p-4 bg-background-card",
          className
        )}
      >
        {children}
      </div>
    </div>
  );
}
